// test2255
(2255 && 0);
